import React from "react";
import { Col, Result, Layout } from "antd";
import { Helmet } from "react-helmet";

const InternalServerError = () => {
  return (
    <Layout>
      <Layout.Content>
        <Col
          xl={{ span: 20 }}
          style={{
            background: "#ffffff",
            margin: "auto",
            marginTop: "4vh",
          }}
        >
          <Helmet title={`500 | Unicon`} />
          <Result
            title="500"
            status="500"
            subTitle="Something went wrong,Please try later"
          />
        </Col>
      </Layout.Content>
    </Layout>
  );
};

export default InternalServerError;
